import React from "react";
import { SocialAuth } from "./SocialAuth";

export function Meta() {
  return (
    <SocialAuth
      platform="meta"
      title="Facebook & Instagram"
      showRefreshButton={true}
    />
  );
}
